import { RouteConfig } from 'vue-router'
import { partnersRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'
import store from '../../store'

const Affiliates = () => import(/* webpackChunkName: "partners" */ '@/pmd/pages/affiliates/Affiliates.vue')
const AffiliateDetail = () => import(/* webpackChunkName: "partners" */ '@/pmd/pages/affiliates/AffiliateDetail.vue')
const AffiliateList = () => import(/* webpackChunkName: "partners" */ '@/pmd/pages/affiliates/AffiliateList.vue')
const AddAffiliate = () => import(/* webpackChunkName: "partners-edit" */ '@/pmd/pages/affiliates/AddAffiliate.vue')
const UpdateAffiliate = () =>
  import(/* webpackChunkName: "partners-edit" */ '@/pmd/pages/affiliates/UpdateAffiliate.vue')
const AffiliateSignup = () =>
  import(/* webpackChunkName: "partners-signup" */ '@/pmd/pages/affiliates/AffiliateSignup.vue')

const token: String[] = ['YuTUZlUtrwBtvmgByZDW', '5DP4iH6HLkQsiKESj6rh']
export const partners: RouteConfig[] = [
  {
    path: '/partners',
    component: Affiliates,
    beforeEnter: requireAuth,
    children: [
      {
        path: '',
        name: partnersRoutes.default,
        component: AffiliateSignup,
        beforeEnter: requireAuth,
      },
      {
        path: 'list',
        name: partnersRoutes.list,
        component: AffiliateList,
        beforeEnter: requireAuth,
      },
      {
        path: 'add',
        name: partnersRoutes.add,
        component: AddAffiliate,
        beforeEnter: (to, from, next) => {
          // @ts-ignore
          if (token.indexOf(store.state.user.user.company_id) !== -1) {
            next()
          } else {
            next({ path: '/agency_dashboard/' })
          }
        },
      },
      {
        path: 'update/:id',
        name: partnersRoutes.update,
        component: UpdateAffiliate,
        beforeEnter: (to, from, next) => {
          if (token.indexOf(store.state.user.user.company_id) !== -1) {
            next()
          } else {
            next({ path: '/agency_dashboard/' })
          }
        },
      },
      {
        path: 'detail/:affiliate_id',
        name: partnersRoutes.detail,
        component: AffiliateDetail,
        beforeEnter: requireAuth,
      },
    ],
  },
]
